import React from "react";
import Button from "./Button";
import { Link } from "react-router-dom";

const CreditCard = ({
  title,
  img,
  joining_fees,
  renewal_fees,
  id,
  apply,
  isComparision = false,
  onComparisionClick,
  lang = "english"
}) => {
  return (
    <div className="w-[100vw] md:w-full rounded-[10px]  flex justify-center ">
      <div className=" h-[100%] w-[328px] md:w-[360px] rounded-[15px] shadow-xl">
        <div className="flex justify-center pt-6 pb-1">
          <img
            className="w-[220px] h-[142.4px] md:w-[292px] md:h-[189px] object-contain"
            src={img}
            alt=""
          />
        </div>
        <div className=" flex justify-center">
          <p className="w-[70vw] text-center mx-1 h-[11px] md:text-[20px] font-montserrat md:leading-[22px]  font-semibold mt-2 items-center text-[14px] text-black leading-[17.07px]">
            {title}
          </p>
        </div>

        <div className=" mt-2 mb-5 p-5  flex flex-col font-montserrat md:mb-2 ">
          <div className="flex justify-start py-4">
            <p className="text-xs ml-2 md:ml-4 text-[#00C6CA] font-medium w-32 md:text-[16px] md:w-32  md:leading-[19.5px]">
              Joining Fees{" "}
            </p>
            <div className="flex  ml-10  w-fit ">
              <p className="text-xs text-[#5C5A5A] w-[100%] ml-12 font-medium md:text-[16px] md:leading-[19.5px]">
                Rs. {joining_fees}
              </p>
            </div>
          </div>
          <div className="flex ml-2 md:ml-4 justify-start pt-2 pb-0">
            <p className="text-xs text-[#00C6CA] font-medium w-32 md:text-[16px] md:w-32  md:leading-[19.5px]">
              Renewal Fees{" "}
            </p>
            <div className="flex  ml-10  w-fit ">
              <p className="text-xs text-[#5C5A5A] w-[100%] ml-12 font-medium md:text-[16px] md:leading-[19.5px]">
                Rs. {renewal_fees}
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-around  px-5 pb-5 pt-0">
          {isComparision ?
            <div onClick={onComparisionClick}>
              <Button
                name={"Compare"}
                bg="bg-[#FFFFFF]"
                textcolor="text-[#00C6CA]"
                bordercolor="border-[#00C6CA]"
                borderradius="rounded-[5px]"
                textsize="text-[10px] md:text-[16px]"
                width="w-[128px] md:w-[145px]"
                height="h-[30px]"
                displayflex="flex"
                justifycontent="justify-center"
                alignitems="items-center"
              />
            </div> :

            <Link to={`/${lang}/credit-card/${id}`}>
              <Button
                name={"View Details"}
                bg="bg-[#FFFFFF]"
                textcolor="text-[#00C6CA]"
                bordercolor="border-[#00C6CA]"
                borderradius="rounded-[5px]"
                textsize="text-[10px] md:text-[16px]"
                width="w-[128px] md:w-[145px]"
                height="h-[30px]"
                displayflex="flex"
                justifycontent="justify-center"
                alignitems="items-center"
              />
            </Link>
          }

          <Link to={`${apply}`} target="_blank" rel="noopener noreferrer">
            <Button
              name="Apply Now"
              bg="bg-[#00C6CA]"
              textcolor="text-[#FFFFFF]"
              bordercolor="border-[#00C6CA]"
              borderradius="rounded-[5px]"
              textsize="text-[10px] md:text-[16px]"
              width="w-[128px] md:w-[140px]"
              height="h-[30px]"
              displayflex="flex"
              justifycontent="justify-center"
              alignitems="items-center"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CreditCard;
